'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCardPaywall = function ContentCardPaywall(_ref) {
  var funnelUrl = _ref.funnelUrl,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-content-card__paywall' },
    _react2.default.createElement(
      'div',
      { className: 'quiver-content-card__paywall__message' },
      'Access Premium Analysis'
    ),
    _react2.default.createElement(
      'a',
      {
        className: 'quiver-content-card__paywall__link',
        href: funnelUrl,
        onClick: onClick
      },
      'Go Premium'
    )
  );
};

ContentCardPaywall.propTypes = {
  funnelUrl: _propTypes2.default.string.isRequired,
  onClick: _propTypes2.default.func,
  message: _propTypes2.default.string
};

ContentCardPaywall.defaultProps = {
  onClick: null,
  message: null
};

exports.default = ContentCardPaywall;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ContentCardPaywall/ContentCardPaywall.js
// module id = 565
// module chunks = 11